module.exports = __webpack_public_path__ + "static/media/pk.f585306a.webp";